import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import * as reportApi from '../api/PomReport';
import { IPomReportCategoryData, IPomReportCategorySumItem, IPomReportDataCategory, IPomReportDataInfo } from '../util/DataModelInterface'
import { Spinner } from '../components/Spinner';
import { statusView } from '../components/CommonControls';
import { useLocation } from 'react-router-dom';
import { PomList } from '../components/PomList';
import useToastHandler from '../hooks/useToastHandler';
import { getDeadline } from '../util/FormatDateUtil';

export const BookkeepingReport = () => {
    const { state } = useLocation();
    const { addToast } = useToastHandler();

    const [categories, setCategories] = useState([] as IPomReportCategoryData[]);
    const [reportData, setReportData] = useState({} as IPomReportDataCategory);
    const [reportInfoData, setReportInfoData] = useState({} as IPomReportDataInfo);
    const [reportCatSumData, setReportCatSumData] = useState({} as {[x: string]: IPomReportCategorySumItem});
    const [loading, setLoading] = useState(false);
    const [reportStatus, setReportStatus] = useState(state.status);
    const [period, ] = useState(state.period);
    const [companyId, ] = useState(state.companyId);
    const [companyName, ] = useState(state.companyName);
    const [errorText, setErrorText] = useState("");

    const year = period.split("-")[0];
    const month = period.split("-")[1];
    const timePeriod = month + "/" + year;

    useEffect(() => {
        setErrorText("");

        const fetchDataAsync = async () => {
            try {
                setLoading(true);
                const data1 = await reportApi.getReport(companyId, period);
                console.log("Pom repor[t" + period + "] - data: " + JSON.stringify(data1));
                if (data1?.result) {
                    setReportData(data1.result.categories);
                    setReportInfoData(data1.result.info);
                    setReportCatSumData(data1.result.catSums);
                    setReportStatus(data1.result.info ? data1.result.info.status : "Missing");
                }
                else if (data1?.error) {
                    addToast(data1.error, 'reports', 'fetch');
                    setErrorText(data1.error.value);
                }

                const data2 = await reportApi.getCategories();
                // console.log("Pom categories - data", data2);
                if (data2?.error) {
                    addToast(data2.error, 'reports', 'fetch');
                    setErrorText(data2.error.value);
                } else if (data2) {
                    setCategories(data2);
                }
                setLoading(false);
            } catch (error) {
                return error;
            }
          }
        fetchDataAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId, period]);


    return (
        <>
        <Spinner active={loading} />
        { !errorText &&
        <div id="reportinfo">
            <Form action="#" id="reportForm">

              <div className="action-buttons py-4 d-flex flex-row align-items-start">
                <div className="page-header">
                  {/* <h1><FormattedMessage id="report.header"/></h1> */}
                  <h1>{companyName} - {timePeriod}</h1>
                  <p className="info"><i className="fa fa-info-circle me-2"></i><FormattedMessage id="report.header.info"/></p>
                </div>

                <div className="ms-auto d-flex flex-row align-items-center">
                  <p className="state me-4 m-0">
                    {
                        statusView(reportStatus, getDeadline(new Date(period)) )
                    }
                  </p>
                </div>

              </div>

              { categories && categories.length > 0 &&
                  <PomList
                      categories={categories}
                      reportData={reportData}
                      reportInfoData={reportInfoData}
                      reportCatSumData={reportCatSumData}
                      period={period}
                      companyName={companyName}
                  />
              }

            </Form>
        </div>
        }
        { errorText &&
            <div id="reportinfo">
                {errorText}
            </div> }
        </>
    );
};